import "./App.scss"
import React, { Component } from "react"
import { authStore, productStore } from "./stores"
import { Switch, Redirect } from "react-router"
import { BrowserRouter, Route, Link } from "react-router-dom"
import { observer } from "mobx-react"
import { Icon, AppHeader, AppPanel, AppSidebar } from "./lib"
import styled from "styled-components"
import Storefront from "./storefront/Storefront"
import Products from "./products/Products"
import OrderList from "./orders/OrderList"
import Orders from "./orders/Orders"

import DashboardBlankSlate from "./assets/dashboard-blank-slate.svg"

const ToDoItem = styled.div`
  width: 30%;
  height: 210px;
  padding: 10px;
  border: 1px solid #eee;
  cursor: pointer;
  text-align: center;
  border-radius: 10px;
  border: 2px solid rgba(0, 0, 0, 0.05);
  a {
    padding-top: 20px;
    text-decoration: none;
    color: #333;
    display: block;
    width: 100%;
    height: 100%;
  }

  &:hover {
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  }

  h2 {
    font-size: 20px;
    padding: 6px;
    opacity: 0.8;
    font-weight: 600;
  }

  p {
    font-size: 13px;
    opacity: 0.7;
    line-height: 18px;
  }

  p.action {
    color: #6079f2;
    padding-top: 10px;
    font-size: 15px;
    opacity: 1;
  }
`

@observer
export default class Dashboard extends Component {
  render() {
    var store = authStore.store
    return (
      <div>
        {authStore.storePurchaseTotals.get("numPurchases") ? (
          <AppHeader
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-end",
            }}>
            <h1>Last 30 days profit: ${authStore.last30DaysProfit}</h1>
          </AppHeader>
        ) : (
          <AppHeader>
            <h1>Welcome to your dashboard!</h1>
          </AppHeader>
        )}
        <AppPanel>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
            }}>
            <ToDoItem>
              <Link to="/products/add">
                <Icon name="product" size={30} color="#6079f2" />
                <h2>
                  Design a New<br /> Product
                </h2>
                <p>Start filling your store with custom creations!</p>
                <p className="action">
                  Let's Go!&nbsp;&nbsp;
                  <Icon name="forward" size={12} color="#6079f2" />
                </p>
              </Link>
            </ToDoItem>
            <ToDoItem>
              <Link to="/payment">
                <Icon name="payment" size={30} color="#6079f2" />
                <h2>
                  Setup Your<br /> Payment
                </h2>
                <p>Use Stripe Connect to get paid quickly and securely.</p>
                <p className="action">
                  Get Paid&nbsp;&nbsp;
                  <Icon name="forward" size={12} color="#6079f2" />
                </p>
              </Link>
            </ToDoItem>
            <ToDoItem>
              <Link to="/embed">
                <Icon name="code" size={30} color="#6079f2" />
                <h2>
                  Embed Your<br /> Custom Store
                </h2>
                <p>Just add your custom script tag to your site.</p>
                <p className="action">
                  Start Selling&nbsp;&nbsp;
                  <Icon name="forward" size={12} color="#6079f2" />
                </p>
              </Link>
            </ToDoItem>
          </div>

          {authStore.recentStorePurchases.keys().length ? (
            <div style={{ display: "flex", paddingTop: 50 }}>
              <div style={{ width: "35%" }}>
                <h4>{authStore.recentStorePurchases.keys().length} Orders</h4>
                <p style={{ paddingBottom: 10 }}>in the last 30 days</p>
                <OrderList limit={5} />
                <Link style={{ display: "block", marginTop: 10 }} to="/orders">
                  View all orders ›
                </Link>
              </div>
              <div style={{ width: "40%" }}>
                <h4 style={{ paddingBottom: 20 }}>Most Popular Products</h4>
                {productStore.products
                  .keys()
                  .map(x => {
                    return {
                      key: x,
                      prod: productStore.products.get(x) || {},
                      totals: authStore.storePurchaseProducts.get(x) || {},
                    }
                  })
                  .sort((a, b) => a.totals.numSold - b.totals.numSold)
                  .map(x => (
                    <div
                      key={x.key}
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        paddingTop: 10,
                      }}>
                      {x.prod.images ? (
                        <img
                          src={x.prod.images[0]}
                          style={{ width: 50, height: 50 }}
                        />
                      ) : null}
                      <div
                        style={{
                          width: "calc(100% - 50px)",
                          textAlign: "right",
                        }}>
                        <p>{x.prod.name}</p>
                        <p>{x.totals.numSold || 0} sold</p>
                      </div>
                    </div>
                  ))}
              </div>
              <div style={{ width: "25%", textAlign: "right" }}>
                <p>Total Sales</p>
                <h1
                  style={{
                    fontWeight: 300,
                    paddingBottom: 20,
                    color: "#B5C1FA",
                  }}>
                  {authStore.storePurchaseTotals.get("numPurchases")}
                </h1>
                <p>Total Volume</p>
                <h1
                  style={{
                    fontWeight: 300,
                    paddingBottom: 20,
                    color: "#B5C1FA",
                  }}>
                  ${authStore.storePurchaseTotals.get("totalVolume").toFixed(2)}
                </h1>
                <p>Total Profit</p>
                <h1
                  style={{
                    fontWeight: 300,
                    paddingBottom: 20,
                    color: "#B5C1FA",
                  }}>
                  ${authStore.storePurchaseTotals.get("totalProfit").toFixed(2)}
                </h1>
              </div>
            </div>
          ) : (
            <div style={{ position: "relative", paddingTop: 60 }}>
              <img src={DashboardBlankSlate} style={{ width: "100%" }} />
              <div
                style={{
                  position: "absolute",
                  width: "100%",
                  maxWidth: 400,
                  top: 0,
                  left: 0,
                  right: 0,
                  textAlign: "center",
                  opacity: 0.7,
                  marginTop: 155,
                  marginBottom: 50,
                  marginLeft: "auto",
                  marginRight: "auto",
                }}>
                <h4 style={{ marginBottom: 5 }}>
                  You haven't sold any products yet.
                </h4>
                <p style={{ opacity: 0.7 }}>
                  Here you'll see your latest orders, highest performing
                  products, and other stats on sales.
                </p>
              </div>
            </div>
          )}
        </AppPanel>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Dashboard.js